import React, { useContext } from 'react';
import { LinkMenuItem } from '@atlaskit/navigation-system';
import { AnalyticContext } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-recent/src/common/controllers/analytic-context/index.tsx';
import type { JiraRecentOLFItem } from '../../types.tsx';

export function RecentMenuLinkItemAdaptor(params: JiraRecentOLFItem): React.JSX.Element {
	const { href, elemBefore, primaryLabel, secondaryLabel, tertiaryLabel, analytics, onClick } =
		params;

	const description = secondaryLabel
		? `${secondaryLabel}${tertiaryLabel ? ` • ${tertiaryLabel}` : ''}`
		: '';

	const { fireUIAnalyticForRecentItems } = useContext(AnalyticContext);

	return (
		<LinkMenuItem
			elemBefore={elemBefore}
			href={href || ''}
			description={description}
			onClick={(event) => {
				fireUIAnalyticForRecentItems(analytics);
				// It's important to call onClick so that the flyout closes when the menu item is clicked
				onClick?.(event);
			}}
		>
			{primaryLabel}
		</LinkMenuItem>
	);
}
